"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PurchaseButtonResponseType = void 0;
var PurchaseButtonResponseType;
(function (PurchaseButtonResponseType) {
    PurchaseButtonResponseType["SUCCESS"] = "SUCCESS";
    PurchaseButtonResponseType["ERROR"] = "ERROR";
})(PurchaseButtonResponseType = exports.PurchaseButtonResponseType || (exports.PurchaseButtonResponseType = {}));
